import { IinitialMainContactsState } from 'interfaces/mainContacts.interface';

const initialMainContactsState: IinitialMainContactsState = {
  contacts: [],
  contactSelected: null,
  isLoadingContacts: true,
  getMainContacts: () => Promise.resolve(false),
  selectContact: () => {},
  createContact: () => Promise.resolve(false),
  removeContact: () => Promise.resolve(false),
  updateContact: () => Promise.resolve(false),
};

export default initialMainContactsState;
